  
<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
         <SmallSquare class='m-b-45' content='1.统一管理的礼品总库，可用于各个应用模块的关联调用，如上架到积分商城作为兑换或营销活动作为奖品发放。
         2.礼品加入回收站后，各个应用模块将不能再进行调用，但不影响之前已调用的礼品状态' />
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="礼品名称" name='gift_name'>
          <a-input v-model:value="search.gift_name" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="礼品分类" name='level_id'>
          <a-cascader :options="loadData" :field-names="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择礼品分类" change-on-select @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click='reset'>重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" ghost @click="()=> {$router.push('/product/gift/gift/management/createGift')}">上传礼品</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a @click="()=>$router.push({path:'/product/gift/gift/management/createGift?id',query:{id:record.id}})" href="javascript:;">修改</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
    </a-card>
  </a-layout>
</template>
<script>
import {DownOutlined} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { getGift,getGiftRecoveryList,deleteGift,createGiftRecovery, getGiftCate} from "@/api/product";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  gift_name: "",
  stock_num:'',
  page: 1,
  limit: 10,
};
export default {
  name:'giftList',
  components: {
    DownOutlined
  },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([
    ]);
    const state = reactive({
      listLoading: false,
      time: [],
      total: 1,
      loadData:[],
    });
    let columns = [
      {
        title: "礼品名称",
        dataIndex: "gift_name",
        key: "gift_name",
      },
      {
        title: "礼品库分类",
        dataIndex: "age",
        key: "age",
        customRender:({record})=>{
            return record.category.name
        } 
      },
      {
        title: "价格/元",
        dataIndex: "market_price",
        key: "market_price",
      },
      {
        title: "库存",
        dataIndex: "stock_num",
        key: "stock_num",
      },
      {
        title: "排序",
        dataIndex: "sort",
        key: "sort",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const momentTime = inject("momentTime");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 获取分类

  const initCate = async () => {
      let result = await getGiftCate().then((res) => res.data);
      state.loadData = result.data;
    };
    //删除
    const recovery = (e,type) => {
      $Modal.confirm({
        centered:true,
        content: `您确定要将该礼品${type=='del'?'移入回收站？':'从回收站还原'}`,
        onOk:async () => {
          let res = await createGiftRecovery({id:e.id}).then(res => res.data);
          if (iscode(res)) {
            initData(search.value);
            $Modal.destroyAll()
          }
        }
      })
    };
    const del=(e)=>{
      $Modal.confirm({
        centered:true,
        content: `您确定要将该礼品删除后无法还原`,
        onOk:async () => {
          let res = await deleteGift(e.id).then(res => res.data);
          if (iscode(res)) {
            initData(search.value);
            $Modal.destroyAll()
          }
        }
      })
    }
    // tabs 点击
    const active=ref(1)
    const callback = (e) => {
      active.value=e
      reset()
      initData(search.value);
    };
    const form=ref()
    const reset=()=>{
      form.value.resetFields()
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
         let res
         if(active.value==1){
         res = await getGift(values).then((res) => res.data);
         }else{
         res = await getGiftRecoveryList(values).then((res) => res.data);
         }
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
    initCate()

    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      recovery,
      del,
      active,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      momentTime,
      callback,
      reset,
      form
    };
  },
};
</script>